import React from 'react'
import { useTranslation } from 'react-i18next'
import { MenuPageHomeScreenWidget, MenuPage, MenuPageItem } from '~/models'
import { observer } from '~/ui/component'
import { Grid, Markdown, Tile } from '~/ui/components'
import { createUseStyles, fonts, layout } from '~/ui/styling'
import HomeScreenWidget from './HomeScreenWidget'
import { register } from './registry'

export interface Props {
  options: MenuPageHomeScreenWidget['options']
}

const MenuPageWidget = observer('MenuPageWidget', (props: Props) => {

  const {page} = props.options

  const [t] = useTranslation('home')

  const caption = page instanceof MenuPage ? page.caption : null
  const items   = page instanceof MenuPage ? page.items ?? [] : []

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <HomeScreenWidget title={page?.title ?? t('title')}>
        {caption != null && (
          <Markdown classNames={$.caption}>
            {caption}
          </Markdown>
        )}
      {items.length < 3 ? (
        <Grid
          classNames={$.mediumGrid}
          columns={`repeat(auto-fit, minmax(0, min(${maxTileWidth}px, calc(50% - 16px))))`}
          gap={layout.padding.inline.l}
        >
          {items.map(renderTile)}
        </Grid>
      ) : items.length < 4 ? (
        <Grid
          classNames={$.mediumGrid}
          columns={`repeat(auto-fit, minmax(0, min(${maxTileWidth}px, calc(33.33% - 16px))))`}
          gap={layout.padding.inline.l}
        >
          {items.map(renderTile)}
        </Grid>
      ) : (
        <Grid
          columns={`repeat(auto-fit, minmax(${minTileWidth}px, 1fr))`}
          gap={layout.padding.inline.l}
        >
          {items.map(renderTile)}
        </Grid>
      )}
      </HomeScreenWidget>
    )
  }

  function renderTile(item: MenuPageItem) {
    return (
      <Tile
        key={item.link.href}
        image={item.image}
        label={item.caption}
        align='center'
        classNames={$.tile}
        {...item.link}
      />
    )
  }

  return render()

})

const minTileWidth  = 160
const maxTileWidth  = 280

const useStyles = createUseStyles(theme => ({
  caption: {
    maxWidth: layout.columnWidth,
    color:    theme.colors.fg.dark.dim,
    ...fonts.responsiveFontStyle(theme.guide.fonts.small),
  },

  mediumGrid: {
    maxWidth: '890px',
  },

  tile: {
    aspectRatio: '1 / 1.1',
  },
}))

register('menu-page', MenuPageWidget)